import { $generateNodesFromDOM } from "@lexical/html";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { CLEAR_HISTORY_COMMAND, $getRoot } from "lexical";
import { useEffect } from "react";

export const SetInitialValuePlugin: React.FC<{ initHtml: string }> = ({ initHtml = "" }) => {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    if (editor && initHtml) {
      editor.update(() => {
        const root = $getRoot();
        root.clear(); // Clear any existing content

        const parser = new DOMParser();
        const dom = parser.parseFromString(initHtml, "text/html");
        const nodes = $generateNodesFromDOM(editor, dom);

        root.append(...nodes); // Append parsed nodes to the editor root
        editor.dispatchCommand(CLEAR_HISTORY_COMMAND, null); // Clear history after setting the content
      });
    }
  }, [editor, initHtml]);

  return null;
};
